import { useEventPlaylistPage } from '../../../hooks/playlist/use-event-playlist'

export const EventPlaylistPage: React.FC = () => {
  useEventPlaylistPage()
  return null
}
